// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sakura-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
  overflow: hidden;
}

.sakura-petal {
  position: absolute;
  top: -50px;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.sakura-diagonal {
  animation: sakura-fall linear infinite;
}

.sakura-vertical {
  animation: sakura-fall-vertical linear infinite;
}

@keyframes sakura-fall {
  0% {
    transform: translateY(-100px) translateX(0px) rotate(0deg);
    opacity: 1;
  }
  25% {
    transform: translateY(25vh) translateX(-15vw) rotate(90deg);
  }
  50% {
    transform: translateY(50vh) translateX(-30vw) rotate(180deg);
  }
  75% {
    transform: translateY(75vh) translateX(-45vw) rotate(270deg);
  }
  100% {
    transform: translateY(100vh) translateX(-60vw) rotate(360deg);
    opacity: 0.3;
  }
}

/* 对角线飘落的摆动效果 */
.sakura-diagonal:nth-child(even) {
  animation: sakura-fall-sway linear infinite;
}

@keyframes sakura-fall-sway {
  0% {
    transform: translateY(-100px) translateX(0px) rotate(0deg);
  }
  25% {
    transform: translateY(25vh) translateX(-10vw) rotate(90deg);
  }
  50% {
    transform: translateY(50vh) translateX(-25vw) rotate(180deg);
  }
  75% {
    transform: translateY(75vh) translateX(-35vw) rotate(270deg);
  }
  100% {
    transform: translateY(100vh) translateX(-50vw) rotate(360deg);
  }
}

/* 垂直飘落动画 - 主要往下，轻微左右摆动 */
@keyframes sakura-fall-vertical {
  0% {
    transform: translateY(-100px) translateX(0px) rotate(0deg);
    opacity: 1;
  }
  25% {
    transform: translateY(25vh) translateX(3vw) rotate(90deg);
  }
  50% {
    transform: translateY(50vh) translateX(-2vw) rotate(180deg);
  }
  75% {
    transform: translateY(75vh) translateX(4vw) rotate(270deg);
  }
  100% {
    transform: translateY(100vh) translateX(-1vw) rotate(360deg);
    opacity: 0.3;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/SakuraBackground.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE;IACE,0DAA0D;IAC1D,UAAU;EACZ;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,6DAA6D;IAC7D,YAAY;EACd;AACF;;AAEA,eAAe;AACf;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,0DAA0D;EAC5D;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,4DAA4D;EAC9D;EACA;IACE,6DAA6D;EAC/D;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,0DAA0D;IAC1D,UAAU;EACZ;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,2DAA2D;EAC7D;EACA;IACE,0DAA0D;EAC5D;EACA;IACE,4DAA4D;IAC5D,YAAY;EACd;AACF","sourcesContent":[".sakura-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.sakura-petal {\n  position: absolute;\n  top: -50px;\n  pointer-events: none;\n  user-select: none;\n}\n\n.sakura-diagonal {\n  animation: sakura-fall linear infinite;\n}\n\n.sakura-vertical {\n  animation: sakura-fall-vertical linear infinite;\n}\n\n@keyframes sakura-fall {\n  0% {\n    transform: translateY(-100px) translateX(0px) rotate(0deg);\n    opacity: 1;\n  }\n  25% {\n    transform: translateY(25vh) translateX(-15vw) rotate(90deg);\n  }\n  50% {\n    transform: translateY(50vh) translateX(-30vw) rotate(180deg);\n  }\n  75% {\n    transform: translateY(75vh) translateX(-45vw) rotate(270deg);\n  }\n  100% {\n    transform: translateY(100vh) translateX(-60vw) rotate(360deg);\n    opacity: 0.3;\n  }\n}\n\n/* 对角线飘落的摆动效果 */\n.sakura-diagonal:nth-child(even) {\n  animation: sakura-fall-sway linear infinite;\n}\n\n@keyframes sakura-fall-sway {\n  0% {\n    transform: translateY(-100px) translateX(0px) rotate(0deg);\n  }\n  25% {\n    transform: translateY(25vh) translateX(-10vw) rotate(90deg);\n  }\n  50% {\n    transform: translateY(50vh) translateX(-25vw) rotate(180deg);\n  }\n  75% {\n    transform: translateY(75vh) translateX(-35vw) rotate(270deg);\n  }\n  100% {\n    transform: translateY(100vh) translateX(-50vw) rotate(360deg);\n  }\n}\n\n/* 垂直飘落动画 - 主要往下，轻微左右摆动 */\n@keyframes sakura-fall-vertical {\n  0% {\n    transform: translateY(-100px) translateX(0px) rotate(0deg);\n    opacity: 1;\n  }\n  25% {\n    transform: translateY(25vh) translateX(3vw) rotate(90deg);\n  }\n  50% {\n    transform: translateY(50vh) translateX(-2vw) rotate(180deg);\n  }\n  75% {\n    transform: translateY(75vh) translateX(4vw) rotate(270deg);\n  }\n  100% {\n    transform: translateY(100vh) translateX(-1vw) rotate(360deg);\n    opacity: 0.3;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
